import { Asset } from 'models/asset'

export const selectTempDataData = (state: any): Asset | null => {
  return state.getIn(['tempData', 'data'])
}

export const selectTempDataSaveAt = (state: any) => {
  return state.getIn(['tempData', 'savedAt'])
}
